export default __webpack_public_path__ + "static/media/OpenSans-Italic-webfont.620dc68d.ttf";